import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Login from "./pages/Login";
import PrivateRoute from "./components/common/PrivateRoute";

import PrivateLayout from "./components/layout/PrivateLayout";
import { useAuth } from "./context/AuthContext";
import AuthRedirect from "./components/AuthRedirect";
import MigrationDetails from "./pages/MigrationDetails";
import MigrationList from "./pages/MigrationList";
import MigrateAPIs from "./pages/MigrationTool";
import { isTokenExpired } from "./services/auth/isTokenExpired";
import { useCallback, useEffect, useState } from "react";
import SessionExpiredModal from "./components/sessionExpiredModal";

function AppWithAuth() {
  const { logout } = useAuth();
  const [sessionExpired, setSessionExpired] = useState(true);
  useEffect(() => {
    const token = sessionStorage.getItem("token");

    if (isTokenExpired(token)) {
      setSessionExpired(true);
    } else {
      const interval = setInterval(() => {
        const storedToken = sessionStorage.getItem("token");
        if (isTokenExpired(storedToken)) {
          setSessionExpired(true);
          clearInterval(interval);
        }
      }, 600000);

      return () => clearInterval(interval);
    }
  }, []);

  const handleLogout = useCallback(() => {
    setSessionExpired(false);
    logout();
  }, [logout]);

  return (
    <>
      <Router>
        <AuthRedirect />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<PrivateRoute />}>
            <Route element={<PrivateLayout />}>
              <Route path="migrate" element={<MigrateAPIs />} />
              <Route path="migrations" element={<MigrationList />} />
              <Route path="migration/:id" element={<MigrationDetails />} />
            </Route>
          </Route>
        </Routes>
      </Router>
      {sessionExpired && <SessionExpiredModal open={sessionExpired} onConfirm={handleLogout} />}
    </>
  );
}

export default AppWithAuth;
